<template>
  <div >
    <header class="header" id="headTitle">

      <!-- <nav class="navigation"> -->
        <div class="navigation__menu">
          <a class="menu-m uk-navbar-toggle" uk-navbar-toggle-icon href="" uk-toggle="target: #offcanvas-overlay" @click="offcanvas()"></a>
          <!-- Soonnet logo -->
          <a href="https://www.soonnet.org/">
            <img src="../../assets/images/desktop/soonnet-logo.svg">

          </a>

          <nav class="header-nav-wrap desktop-display">
            <ul class="header-menu">
              <li class="header-menu-item" :class="{ current: 4 == selectoption }" @click="change(4)">
                <router-link :to="{ name: 'albumIndex' }" class="header-menu-link">{{ $t("header.albumIndex")
                }}</router-link>
              </li>
              <li class="header-menu-item" :class="{ current: 3 == selectoption }" @click="change(3)">
                <router-link :to="{ name: 'eventList' }" class="header-menu-link">
                  {{ $t("header.eventList") }}
                </router-link>
              </li>
              <li class="header-menu-item blog" style="position: relative" :class="{ current: 10 == selectoption }"
                @click="change(10)">
                <!-- <a :href="`${bases.evi}/articleList`" class="header-menu-link">話題</a> -->
                <div class="blogMenu">
                  <span class="blogMenuLink" @click="$router.push({ name: 'blog' })">{{ $t("header.blog") }}</span>
                  <!-- <router-link
                    style="text-decoration: none"
                    :to="{ name: 'blog' }"
                    >網誌</router-link
                  > -->
                </div>
                <router-link :to="{ name: 'articleList' }" class="header-menu-link">{{ $t("header.articleList")
                }}</router-link>
              </li>
              <!-- <li class="header-menu-item blog" style="position: relative" :class="{ current: 1 == selectoption }" @click="change(1)">
                <div class="blogMenu FeedCloud">
                  <span class="blogMenuLink" @click="$router.push({ name: 'blog' })">{{ $t("Index.FeedCloud") }}</span>
                </div>
                  <router-link :to="{ name: 'VideoIndexN' }" class="header-menu-link">{{ $t("header.VideoIndex")
                  }}</router-link>
              </li> -->
              <li class="header-menu-item" :class="{ current: 1 == selectoption }" @click="change(1)">
                <router-link :to="{ name: 'VideoIndex' }" class="header-menu-link">{{ $t("header.VideoIndex")
                }}</router-link>
              </li>
              <li class="header-menu-item IDFeedCloud" :class="{ current: 11 == selectoption }" @click="change(11)">
                <router-link :to="{ name: 'FeedCloud' }" class="header-menu-link">{{ $t("Index.FeedCloud")
                }}</router-link>
              </li>
            </ul>
          </nav>
        </div>

        <!-- Search -->
        <button type="button" class="desktop-display style-4" @click="showSearchModal()">
          {{ $t('header.search') }}
          <i class="fas fa-search	"></i>
        </button>

        <div class="navigation__options">
          <div class="desktop-display-l mr-2">
            <iframe data-v-d3708e16="" name="weather_inc" src="https://i.tianqi.com/index.php?c=code&amp;id=7" width="180"
              height="20" frameborder="0" marginwidth="0" marginheight="0" scrolling="no"
              style="border: 0px solid rgb(126, 200, 234);"></iframe>
          </div>
          <el-dropdown trigger="click" class="mr-2">
            <span class="el-dropdown-link">
              <i class="fas fa-cloud-upload-alt	"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><router-link  style="color: inherit;" :to="{ name: 'uploadImage' }">{{ $t('header.Uploadphotos') }}</router-link></el-dropdown-item>
              <el-dropdown-item><router-link style="color: inherit;" :to="{name:'SocialVideoUpload'}"> {{ $t('header.Uploadshortvideos') }}</router-link></el-dropdown-item>
              <el-dropdown-item><a @click.prevent="pushBlog()">{{ $t('header.Publishblogposts') }}</a></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 上傳媒體 -->

          <button class="search-m menu-m" @click="showSearchModal()" style="margin-right:10px;margin-top: 2px"><i
              class="	fas fa-search	"></i></button>


          <!-- 網頁語言 -->
          <el-dropdown trigger="click" class="lang-button desktop-display mr-3">
            <span class="el-dropdown-link">
              <i class="fas fa-globe-asia	"></i><span>{{ I18nValue == 'zh' ? '繁體' : 'English' }}</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><a @click="setIl18('en')" v-show="I18nValue == 'zh'">English</a></el-dropdown-item>
                <el-dropdown-item><a @click="setIl18('zh')" v-show="I18nValue == 'en'">繁體</a></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-show="getusers == '' || getusers == null">
            <el-dropdown>
              <span>
                <avatarVue :src="getimage" @click.native="cusLogin()" style="cursor: pointer;">
                </avatarVue>
              </span>
              <el-dropdown-menu style="display: none;"></el-dropdown-menu>
            </el-dropdown>
          </div>
          <div v-show="getusers !== '' && getusers !== null">
            <el-dropdown>
              <span style="position: relative; color: red">
                <div class="notification_pop" @click="showMessage" style="cursor: pointer;" v-if="messageInfo &&
                  messageInfo.items &&
                  messageInfo.items.length
                  ">
                  {{
                    messageInfo.items.length > 100
                    ? "99+"
                    : messageInfo.items.length
                  }}
                </div>
                <avatarVue :src="getimage"  > </avatarVue>
              </span>
              <el-dropdown-menu slot="dropdown">
                <router-link :to="{ name: 'customerPublish' }">
                  <el-dropdown-item>
                    <i class="fa fa-user-circle fa-fw mr-3"></i>{{ $t('header.customerPublish') }}
                  </el-dropdown-item>
                </router-link>
                <router-link :to="{ name: 'feed' }">
                  <el-dropdown-item>
                    <i class="el-icon-postcard fa-fw mr-3"></i>{{ $t('header.feed') }}
                  </el-dropdown-item>
                </router-link>
                <a href="javascript:void(0)" @click="Gotolive()">
                  <el-dropdown-item>
                    <i class="el-icon-mobile-phone fa-fw mr-3"></i>{{ $t('header.mobile') }}
                  </el-dropdown-item>
                </a>
                <router-link target="_blank" :to="{ name: 'admin' }">
                  <el-dropdown-item v-if="user && user.isAdmin">
                    <i class="fa fa-tachometer-alt fa-fw mr-3"></i>{{ $t('header.admin') }}
                  </el-dropdown-item>
                </router-link>

                <a href="javascript:void(0);" @click="loginout()">
                  <el-dropdown-item>
                    <!-- <router-link :to="{name:'admin'}" tag="a" target="_blank"> -->
                    <i class="fa fa-sign-out-alt fa-fw mr-3"></i>{{ $t('header.loginout') }}

                    <!-- </router-link> -->
                  </el-dropdown-item>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

        </div>
      <!-- </nav> -->


    </header>
    <!-- 目錄 (流動版) -->
    <!-- 左邊菜單 -->
    <VideoNavigation style="display:none" ref="offcanvas"></VideoNavigation>

    <!-- ./左邊菜單 -->

    <div id="myModal" class="modal fade show" style="padding-right: 5px" aria-modal="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('header.Latestnotice') }}</h5>
            <button type="button" class="close" data-dismiss="modal">×</button>
          </div>
          <div class="modal-body notification-fm">
            <div v-for="(item, ix) in messageInfo.items" :key="ix">
              <div class="notification-box">
                <div class="txt-blog">
                  <!-- <i class="fas fa-code" /> -->
                  <div :class="messageList[item.sgL_Type] ? messageList[item.sgL_Type].icon_bg : 'icon_bg3'">
                    <i :class="messageList[item.sgL_Type] ? messageList[item.sgL_Type].icon : 'fas fa-code'"></i>
                  </div>
                  {{ messageList[item.sgL_Type] ? messageList[item.sgL_Type].title : '其他' }}
                  <div class="close-btn" @click="UpdateRead(item)">x</div>
                  <div class="txt">{{ item.sgL_CreateTimeE }}</div>
                  <messageLink :item="item" class="chat-link">{{
                    item.sgL_Title
                  }}</messageLink>
                </div>
                <div class="">
                  <div class="hub">
                    <img :src="item.userLogoSmail" class="notification-photo" />
                  </div>
                  <messageLink :item="item">
                    <div class="contant">
                      <b>{{ item.sgL_UserName }}</b>
                      <div>{{ item.sgL_Content }}</div>
                    </div>
                  </messageLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="searchModal" tabindex="-1" aria-labelledby="searchModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="searchModalLabel">{{ $t('Customer.customerFavorite.search') }}</h1>
            <button type="button" class="btn-close" @click="closeSearchModal()"><i class="fa fa-times fa-fw"></i></button>
          </div>
          <div class="modal-body">
            <div class="m-search">
              <input type="text" class="form-control mb-3 fc" name="word" v-model="searchtext" :placeholder="$t('Customer.customerFavorite.search')"
                @input="testThrottle()" list="datalistOptions-air" id="search-keywords" ref="searchkey"
                @change="changIpt()">



              <datalist id="datalistOptions-air">
                <option :value="getSearchTitle(item)" v-for="(item, idx) in searchHot" :key="idx" />
              </datalist>
              <select class="form-select mb-3" ref="select" id="selectedval">
                <option selected value="99">{{ $t('header.Checkprofile_') }}</option>
                <option value="0">{{$t('header.articleList')}}</option>
                <option value="1">{{ $t('header.eventList') }}</option>
                <option value="2">{{ $t('header.albumIndex') }}</option>
                <option value="3">{{ $t('header.VideoIndex') }}</option>
                <option value="4">{{ $t('Video.search.Shortvideo') }}</option>
                <option value="5">{{ $t('header.blog') }}</option>
              </select>
            </div>
            <div class="docsearch-item">
              <p>{{ $t('header.RecentSearches') }}</p>
              <div class="toast history-search fade show" v-for="(item, idx) in hostList" :key="idx">

                <div class="hidtory-toast">
                  <div class="toast-body">
                    <a href="javascript:void(0)" @click="toSearch('A', item.text, item.type)">
                      <i class="fa fa-history" aria-hidden="true"></i>{{ `${item.text} - ${item.title} ` }}
                    </a>
                    <!-- <router-link :to="{ name: 'search', query: { q: item.text, type: item.type } }" @click="toSearch()"> -->
                    <!-- </router-link> -->

                  </div>
                  <div>
                    <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="delhot(idx)"><i
                        class="fa fa-times fa-fw"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <!-- <router-link :to="{name : 'search', query:{q: searchtext }}"> -->
            <button class="search-button" @click="toSearch()">{{ $t('Customer.customerFavorite.search') }}</button>
            <!-- </router-link> -->


          </div>
        </div>
      </div>
    </div>

           
  </div>
</template>

<script>
import { Message } from "element-ui";
import base from "../../api/httpApi/base";
import avatarVue from "./avatar.vue";
import socketTools from "../../assets/js/websocketTools";
import { nanoid } from "nanoid";
import messageLink from "@/components/common/messageLink";
import _ from "lodash";
import VideoNavigation from "@/components/Video/VideoNavigation.vue";
// import { FB } from 'vue-facebook-login-component'
export default {
  name: "headTitle",
  components: {
    avatarVue,
    messageLink,
    VideoNavigation
  },
  data () {
    return {
      allData: [],
      pageData: [],
      searchHot: [],
      showFootData: [],
      isShowMobileMenu: false,
      isShowProgress: false,
      loginbtn: false,
      searchtext: "",
      seachtype: 0,
      selectoption: 0,
      image: "https://api.soonnet.org/Userlogo_Smail.jpg",
      user: null,
      bases: null,
      messageInfo: {},
      hostList: this.$cookies_.getItem('hostList') ? JSON.parse(this.$cookies_.getItem('hostList')) : [],
      loginmodel: {
        name: "",
        password: "",
      },
      liveUrl_: null,
      I18nValue: this.$i18n.locale,
      messageList: {
        AddMessage: { icon_bg: "icon_bg", title: "留言", icon: "fas fa-comment" },
        socketMsg: { icon_bg: "icon_bg", title: "私訊", icon: "fas fa-comment" },
        like: { icon_bg: "icon_bg2", title: "讚", icon: "fas fa-thumbs-up" },
        Community: { icon_bg: "icon_bg3", title: "群組", icon: "fas fa-comment-alt" },
        AddFriends: { icon_bg: "icon_bg3", title: "好友申請", icon: "fas fa-user-plus" },
        CreateFriends: { icon_bg: "icon_bg3", title: "好友申請", icon: "fas fa-comment-alt" },
        AcceptFriends: { icon_bg: "icon_bg3", title: "好友同意申請", icon: "fas fa-user-check" },
        AddGroup: { icon_bg: "icon_bg3", title: "群組申請", icon: "fas fa-comment-alt" },
        AddCollection: { icon_bg: "icon_bg4", title: "收藏", icon: "fas fa-bookmark" },
        MyMessage: { icon_bg: "icon_bg5", title: "收到個人訊息", icon: "far fa-comments" },
        BLog: { icon_bg: "icon_bg6", title: "網誌", icon: "fab fa-bimobject" },
        addSub: { icon_bg: "icon_bg6", title: "訂閱", icon: "fab fa-bimobject" },
      },
      hotList: [
        { title: "全部", sgL_Type: 99 },
        { title: "話題", sgL_Type: 0 },
        { title: "活動", sgL_Type: 1 },
        { title: "相簿", sgL_Type: 2 },
        { title: "影音", sgL_Type: 3 },
        { title: "短視頻", sgL_Type: 4 },
        { title: "網誌", sgL_Type: 5 },
      ],
      screenWidth:0,



    };
  },

  async created () {
    // ?Liveurl = ${ window.btoa(this.$baseUrl.Liveurl) }
    this.liveUrl_ = `http://live.soonnet.org`;
    // this.liveUrl_ = `/static/index.html?Liveurl=${window.btoa(this.$baseUrl.Liveurl)}`;
    let needScroll = ["/albumviewPhotostream", "/photoview", "/articleview"];
    if (needScroll.indexOf(this.$route.path) > -1) {
      this.isShowProgress = true;
    }
    this.loadFBSDK();
    this.bases = base;
    this.getuser();
    // await this.getContentList();
    this.getFootList();
    this.MessagePushAppSerivceGetAll();
    this.$i18n.locale = this.$cookies_.getItem('AspNetCoreCulture');

  },
   beforeDestroy () {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  mounted () {
    window.addEventListener("resize", this.updateScreenWidth);
    this.selectoption = this.$store.getters.getCurrentIndex;
    let _this = this;
    window.onscroll = function () {
      if (_this.isShowProgress) {
        _this.myFunction();
      }
    };

    $("#datalistOptions-air option").each(function (el) {
      // console.log(el);
    })

    $('.modal-body select#selectedval').each(function () {
      var $this = $(this), numberOfOptions = $(this).children('option').length;
      // console.log($this);
      $this.addClass('select-hidden');
      $this.wrap('<div class="select"></div>');
      $this.after('<div class="select-styled"></div>');

      var $styledSelect = $this.next('div.select-styled');
      $styledSelect.text($this.children('option').eq(0).text());

      var $list = $('<ul />', {
        'class': 'select-options'
      }).insertAfter($styledSelect);

      for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
          text: $this.children('option').eq(i).text(),
          rel: $this.children('option').eq(i).val()
        }).appendTo($list);
        //if ($this.children('option').eq(i).is(':selected')){
        //  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
        //}
      }

      var $listItems = $list.children('li');

      $styledSelect.click(function (e) {
        e.stopPropagation();
        $('div.select-styled.active').not(this).each(function () {
          $(this).removeClass('active').next('ul.select-options').hide();
        });
        $(this).toggleClass('active').next('ul.select-options').toggle();
      });

      $listItems.click(function (e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass('active');
        $this.val($(this).attr('rel'));
        $list.hide();
        //console.log($this.val());
      });

      $(document).click(function () {
        $styledSelect.removeClass('active');
        $list.hide();
      });

    });
  },
  updated () {
    this.selectoption = this.$store.getters.getCurrentIndex;
  },
  methods: {
/**
 * @description : 切换语言
 * @param name {String}
 * @date : 2023-07-28 15:20:50
*/
    setIl18(zh_en){
      this.I18nValue = zh_en;
    },
    updateScreenWidth () {
      this.screenWidth = window.innerWidth;
    },
    offcanvas(){
      // console.log(this.$refs.offcanvas.$el.style.display);
      let el = this.$refs.offcanvas.$el;
      if(el.style.display == "none"){
        el.style.display = "block";
      }else{
         el.style.display = "none";
      }
    },
    changIpt (e) {
      let selected = this.$refs.searchkey.value;
      let hot = this.hotList[_.findLastIndex(this.hotList, { title: selected.split(" - ")[1] })];
      this.searchtext = selected.split(" - ")[0];
      // console.log(selected.split(" - ")[1]);
      // console.log(this.hotList[_.findLastIndex(this.hotList, { title: selected.split(" - ")[1] })].sgL_Type);
      //  console.log(hot);
      if (!hot) {
        return;
      }
      $('#selectedval').val(hot.sgL_Type);
      $('.select-styled')[0].innerText = hot.title;
    },

    testThrottle: _.debounce(async function () {
      this.searchHot = [];
      const { data } = await this.$api.VideoApi.HomeGetSearchResponseList({
        Title: this.searchtext
      });
      if (data.success)
        this.searchHot = data.result.items;
      else this.$message.error(data.error.message);
    }, 500, {
      leading: false,
      trailing: true
    }),
    async HomeGetSearchResponseList () {
      this.searchHot = [];
      const { data } = await this.$api.VideoApi.HomeGetSearchResponseList({
        title: this.searchtext
      });
      if (data.success)
        this.searchHot = data.result.items;
      else this.$message.error(data.error.message);
    },
    Gotolive () {
      const userinfo = JSON.parse(localStorage.getItem("userinfo") ? localStorage.getItem("userinfo") : null);
      if (userinfo) {
        this.$cookies_.setItem('userinfo', JSON.stringify(userinfo), 1000 * 60 * 60 * 24, null, '.soonnet.org');
        this.$cookies_.setItem('token', JSON.stringify(userinfo.accessToken), 1000 * 60 * 60 * 24, null, '.soonnet.org');
      }
      window.open(this.liveUrl_);
    },
    toSearch (e, text, type) {
      let hot = {
        type: e === 'A' ? type : (+this.$refs.select.value),
        text: e === 'A' ? text : this.searchtext,
        title: this.$refs.select.options[this.$refs.select.selectedIndex].text
      };
      let bool = true;
      this.hostList.forEach((item) => {
        if (item.text == hot.text && item.type == hot.type)
          bool = false
      })
      if (bool || e === 'A') {
        this.hostList.unshift(hot);
        this.hostList.length > 10 && this.hostList.pop();
        this.$cookies_.setItem('hostList', JSON.stringify(this.hostList), 1000 * 60 * 60);
      }
      this.$router.push({ name: 'search', query: { q: hot.text, type: hot.type } })
      this.closeSearchModal();
    },
    delhot (idx) {
      this.hostList.splice(idx, 1);
      this.$cookies_.setItem('hostList', JSON.stringify(this.hostList), 1000 * 60 * 60);
    },
    pushBlog () {
      if (this.loginUser === null) {
        this.$router.push({ name: "customerLogin" });
        return;
      }
      //判断是否已认证
      if (!this.loginUser.sgL_IsCheck) {
        //跳转到认证页面
        this.$router.push({
          name: "certification",
          query: { redirect: "/customerPublish?addBlog=true" },
        });
        return;
      } else {
        this.$router.push({
          name: "customerPublish",
          query: {
            addBlog: true,
          },
        });
      }
    },
    MessagePushAppSerivceGetAll () {
      if (this.loginUser) {
        this.$api.common
          .MessagePushAppSerivceGetAll({ SkipCount: 0, MaxResultCount: 100 })
          .then((res) => {
            this.messageInfo = res.data.result;
          });
      }
    },
    UpdateRead (item) {
      this.$api.common
        .MessagePushAppSerivceUpdateRead({ ids: item.ids })
        .then((res) => {
          this.MessagePushAppSerivceGetAll();
        });
    },
    showMessage () {
      $("#myModal").modal("show");
    },
    showSearchModal () {
      $("#searchModal").modal("show");
    },
    closeSearchModal () {
      $("#searchModal").modal("hide");
    },
    async getContentList () {
      const res = await this.$api.permissionApi.GetFootContentList2({
        SkipCount: 0,
        MaxResultCount: 999,
        sgL_IsShow: true,
      });
      this.pageData = res.data.result.items;
    },
    sortList (id) {
      let result = this.allData
        .filter((c) => c.sgL_Parent === id)
        .sort(function (a, b) {
          return a.sgL_Order - b.sgL_Order;
        });
      result
        .filter((c) => c.sgL_IsInternal)
        .forEach((c) => {
          const info = this.pageData.filter(
            (d) => d.id == c.sgL_IsInternaURL
          )[0];
          if (info) {
            c.sgL_IsInternaURL = info.sgL_RequestUrl;
          }
        });
      return result;
    },
    getFootList () {
      this.$api.permissionApi
        .getFootAll({
          SGL_IsShow: true,
          SkipCount: 0,
          MaxResultCount: 999,
        })
        .then((res) => {
          this.allData = res.data.result.items;
          const footData = this.allData
            .filter((c) => c.sgL_Parent === 0)
            .sort(function (a, b) {
              return a.sgL_Order - b.sgL_Order;
            });
          footData.forEach((item) => {
            this.showFootData.push(...this.sortList(item.id));
          });
        });
    },
    menuToggleShow () {
      console.log("aaaa");
      this.isShowMobileMenu = !this.isShowMobileMenu;
    },
    loadFBSDK () {
      const params =
        "#version=v3.3&appId=504404792941839&status=true&cookie=true&xfbml=true&autoLogAppEvents=true";
      (function (d, s, id) {
        // Load the SDK asynchronously
        var js;
        var fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/zh_TW/sdk.js" + params;
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    },
    onFBLogin () {
      this.loadFBSDK();
      const _this = this;
      // 检测FB登录状态
      FB.getLoginStatus(function (response) {
        // statusChangeCallback(response);

        if (response.status === "connected") {
          // 已登录0
          // Has logged into your webpage and Facebook.
          // _this.handleSomething();
        } else {
          // 未登录进行登录
          FB.login(function (res) {
            if (res.status === "connected") {
              // Logged into your webpage and Facebook.
              // _this.handleSomething();
            } else {
              // The person is not logged into your webpage or we are unable to tell.
            }
          });
        }
      });
    },
    cusLogin () {
      // $("#m-header-nav").hide();
      // this.$uikit.offcanvas($("#offcanvas-overlay")).hide();
      this.$refs.offcanvas.$el.style.display = "none";
      this.$router.push({ name: "customerLogin" });
    },
    customerInfo () {
      // $("#m-header-nav").hide();
      // this.$uikit.offcanvas($("#offcanvas-overlay")).hide();
      this.$refs.offcanvas.$el.style.display = "none";
      this.$router.push({ name: "customerInfo" });
    },
    uploadImage () {
      this.$router.push({ name: "uploadImage" });
    },
    getuser () {
      this.user = this.$store.getters.getcustomer;
      if (
        this.user != null &&
        this.user.userId != undefined &&
        this.user.userId != ""
      ) {
        this.image =
          "https://www.soonnet.org/Account/Acc_Resources/" +
          this.user.userId +
          "/Userlogo_Smail.jpg";
      }
    },
    searchword () {
      let local = window.location.href;
      location.href = `${base.evi}/search?q=` + this.searchtext;
    },
    go () {
      this.$router.go(0);
    },
    change (id) {
      this.selectoption = id;
      this.$store.dispatch("updateCurrentIndex", id);
    },
    loginout () {
      this.loginbtn = false;
      this.$store.commit("writecustomer", null);
      this.$store.commit("updatePermission", null);
      this.image = "https://api.soonnet.org/Userlogo_Smail.jpg";
      localStorage.removeItem("userinfo");
      sessionStorage.removeItem("store");
      this.cusLogin();
      this.getuser();
    },
    myFunction () {
      var winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      var height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      var scrolled = (winScroll / height) * 100;
      // document.getElementById("progressBar").style.width = scrolled + "%";
    },
  },
  computed: {
    getSearchTitle (item) {
      return function (item) {
        let el = this.hotList[_.findLastIndex(this.hotList, { sgL_Type: item.sgL_Type })];
        return item.title + " - " + el.title
      };
    },
    getimage () {
      if (this.$store.getters.getcustomer != null) {
        return (
          this.$store.getters.getcustomer.userLogoBig
        );
      } else {
        return "https://api.soonnet.org/Userlogo_Smail.jpg";
      }
    },
    host () {
      return [...new Set(this.hostList.map((i) => i.text))];
    },
    getusers () {
      if (this.user == null) {
        this.user = this.$store.getters.getcustomer;
      }
      return this.user;
    },
  },
  watch: {
    I18nValue: {
      handler (newVal, oldVal) {
        this.$i18n.locale = newVal;
        this.$cookies_.setItem("AspNetCoreCulture", newVal, 1000 * 60 * 60 * 24);
      },
    },
    screenWidth:{
      handler (newVal, oldVal) {
        if(newVal >= 1000 ){
          this.$refs.offcanvas.$el.style.display = "none";
        }
      }
    }
  }
};
</script>

<style>
.indexsearch .el-input .el-input__inner {
  border-radius: 30px;
}

.indexED .el-input .el-input__inner {
  border-radius: 30px;
}
.line-h47{
  line-height: 47px!important;
  cursor: pointer;
  color:#26AD5E !important;
}
#search-keywords:focus {

  border-color: #98d4b1 !important;
}
</style>

<style scoped>
.header-menu-item:hover {
  cursor: pointer;
}


@media (max-width: 767.98px) {
  .el-popper[x-placement^="bottom"] {
    margin-top: initial;
  }
}

.blogMenu {
  bottom: -40px;
  width: 60px;
  height: 40px;
  display: none;
  background-color: white;
  padding: 10px;
  box-sizing: border-box;
  position: absolute;
}

.blog:hover>.blogMenu {
  display: flex;
  justify-content: center;
  align-content: center;
}

.blogMenu .blogMenuLink {
  position: absolute;
  line-height: normal;
}

.hidtory-toast {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Header.vue